export default __webpack_public_path__ + "static/media/credit-card-white.02574dfe.svg";